import { Component, OnInit } from '@angular/core';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { routes } from '@app/consts';
import { SiteSettingsService } from './services/site-settings.service';

@Component({
    selector: 'app-site-settings-page',
    templateUrl: './site-settings-page.component.html',
    styleUrls: ['./site-settings-page.component.scss']
})
export class SiteSettingsPageComponent implements OnInit {
    public routes: typeof routes = routes;
    navList = [];

    constructor(
        public translate: TranslateService,
        public router: Router,
        private moduleConfigurationService: ModuleConfigurationService,
        private siteSettingsService: SiteSettingsService
    ) {
        this.navList = this.siteSettingsService.menuItems;
    }

    ngOnInit(): void {
        this.removeFeaturesWithoutModuleAccess();
    }

    // If the client doesnt have access to a module remove it form the list
    removeFeaturesWithoutModuleAccess() {
        this.navList = this.navList.filter(
            feature => {
                if (feature.module) {
                    return this.moduleConfigurationService.hasModuleAccess(feature.module);
                }
                else {
                    return true;
                }
            }
        )
    }

}
